/**
 * A `Field`-based view which displays the attributes of a given model in a read-only fashion.
 * ## Fields
 * Name | Description
 * --- | ---
 * model | The model associated with the view.
 * fields | The array of `Field` models displayed by the view.
 * @module app/views/admin/mapServices/Layers
 */
import Backbone from "backbone";
import CollectionTableView from "core/views/CollectionTableView";
var LayerView = Backbone.View.extend({
  tagName: "div",
  className: "form-horizontal map-service-layers",

  /**
   * Initializes the control
   * @param  {object} options The options hash.
   * @param {mixed} options.model The model to associate with the view.
   * @param {Array} options.fields The array of `Field` models to display in the view.
   */
  initialize: function (options) {
    this.options = options;
    this.layerCollection = options.layerCollection;
    this.model = this.options.model;
    this.fields = this.options.fields;
  },

  render: function () {
    var view = new CollectionTableView({
      collection: this.layerCollection,
      fields: this.fields,
      allowDelete: false,
      allowSave: false,
      mode: "view",
    });

    view.render();
    this.$el.append(view.$el);
  },
});

export default LayerView;



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/admin/mapServices/Layers.js
// module id = 926
// module chunks = 1